/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdBaseTableProps } from './type';

export const baseTableDefaultProps: TdBaseTableProps = {
  bordered: false,
  columns: [],
  data: [],
  empty: '',
  loading: undefined,
  rowKey: 'id',
  showHeader: true,
  stripe: false,
  tableLayout: 'fixed',
  verticalAlign: 'middle',
};
